import Banner from '@zenbusiness/zui/Banner';
import Divider from '@zenbusiness/zui/Divider';
import SlideSheet from '@zenbusiness/zui/SlideSheet';
import Stack from '@zenbusiness/zui/Stack';
import { superstyled } from '@zenbusiness/zui/styles';
import TextField from '@zenbusiness/zui/TextField';

export const StyledDrawer = superstyled({
  name: 'StyledDrawer',
  tag: SlideSheet,
  styles: () => ({
    '& .ZuiSlideSheet-divider': {
      display: 'none'
    },

    '& .ZuiSlideSheet-content': {
      display: 'flex',
      justifyContent: 'start',
      flexDirection: 'column'
    }
  })
});

export const ContentContainer = superstyled({
  name: 'ContentContainer',
  styles: () => ({
    flex: '1 1 auto'
  })
});

export const StyledTextField = superstyled({
  name: 'StyledTextField',
  tag: TextField,
  styles: ({ theme }) => ({
    '& .MuiOutlinedInput-input': {
      padding: '0.25rem 0.75rem'
    },

    [theme.breakpoints.up('md')]: {
      '& .MuiOutlinedInput-input': {
        paddingBlock: '0.875rem'
      }
    }
  })
});

export const StyledSduCompliance = superstyled({
  name: 'StyledSduCompliance',
  tag: Banner,
  styles: () => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '1rem',
    minHeight: 'fit-content',

    '& .ZuiBanner-actions': {
      width: '100%'
    }
  })
});

export const StyledInputContainer = superstyled({
  name: 'StyledInputContainer',
  tag: Stack,
  styles: ({ theme }) => ({
    gap: '1rem',
    marginTop: '1.5rem',

    [theme.breakpoints.up('sm')]: {
      gap: '0.5rem'
    }
  })
});

export const StyledDesktopDivider = superstyled({
  name: 'DesktopDivider',
  tag: Divider,
  styles: ({ theme }) => ({
    display: 'none',

    [theme.breakpoints.up('md')]: {
      display: 'block'
    }
  })
});
